import ApiCall from 'Helpers/ApiCall';
import { actionType } from 'Config/actionTypes';
import {
  API_SET_CURRENT_COMPANY,
  API_CURRENT_USER,
  API_CHECK_AUTH,
  API_SIGN_OUT,
} from 'Config/api';
import {
  GetAPIBaseURL, getPathMenu,
} from 'Helpers';


export const getCheckAuth =
  () =>
    (dispatch) => {
      ApiCall(
        dispatch,
        actionType.CHECK_AUTH,
        'GET',
        GetAPIBaseURL(),
        API_CHECK_AUTH,
        null,
        '',
        { menu: getPathMenu() }
      );
    };

export const getReportBuilderAuth =
  () =>
    (dispatch) => {
      ApiCall(
        dispatch,
        actionType.REPORT_BUILDER_AUTH,
        'GET',
        GetAPIBaseURL(),
        API_CHECK_AUTH,
        null,
        '',
        { menu: 'report_builder' }
      );
    };

export const getCurrentUser =
  () =>
    (dispatch) => {
      ApiCall(
        dispatch,
        actionType.CURRENT_USER,
        'GET',
        GetAPIBaseURL(),
        API_CURRENT_USER,
        null,
        ''
      );
    };

export const setCurrentCompany =
  (companyId) =>
    (dispatch) => {
      ApiCall(
        dispatch,
        actionType.CURRENT_USER,
        'POST',
        GetAPIBaseURL(),
        API_SET_CURRENT_COMPANY,
        {
          company_id: companyId,
        },
        '',
        '',
        {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      );
    };

export const signOutAuth =
  () =>
    (dispatch) => {
      ApiCall(
        dispatch,
        actionType.SIGN_OUT,
        'POST',
        GetAPIBaseURL(),
        API_SIGN_OUT,
        null,
        '',
      );
    };
